// src/api/itemCategories.js
import api from "./api"; // centralized axios instance with baseURL and token

// 📌 Fetch all item categories
export const getItemCategories = async () => {
  try {
    const res = await api.get("/item-categories/");
    return res.data;
  } catch (err) {
    console.error("Error fetching item categories:", err);
    throw err;
  }
};

// ✅ Create a new item category (admin only)
export const createItemCategory = async (data) => {
  try {
    const res = await api.post("/item-categories/", data);
    return res.data;
  } catch (err) {
    console.error("Error creating item category:", err);
    throw err;
  }
};

// 🔄 Update an item category (admin only)
export const updateItemCategory = async (id, data) => {
  try {
    const res = await api.put(`/item-categories/${id}/`, data);
    return res.data;
  } catch (err) {
    console.error(`Error updating item category ${id}:`, err);
    throw err;
  }
};

// ❌ Delete an item category (admin only)
export const deleteItemCategory = async (id) => {
  try {
    const res = await api.delete(`/item-categories/${id}/`);
    return res.data;
  } catch (err) {
    console.error(`Error deleting item category ${id}:`, err);
    throw err;
  }
};
